import { BREAKPOINTS } from "../config/breakpoints";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import InventoryService from "./Services/InventoryService";
import {
	errorNotification,
	successNotification,
} from "../Generic/Notifications";
import { deepCopy } from "./Reducer";
import styled from "styled-components";
import Card from "../Generic/Card";
import { Cross } from "../Generic/Symbols";
import * as OperationActions from "./Actions/index";
import Button from "../Generic/Button";
import SuccessButton from "../Generic/SuccessButton";
import InputBox from "../Generic/InputBox";
import { SearchBarWithResults } from "./Components/SearchBarWithResult";
import { CSSTransition } from "react-transition-group";
import close from "../Assets/Close.png";
import Dropdown from "../Generic/Dropdown";
import { DOCKING_ACTIONS } from "./Constants";
import { beautifyKey } from "../util/util";
import { zIndex } from "../config/zIndex";

const Page = styled.div`
	display: flex;
	height: max-content;
	overflow-y: auto;
	overflow-x: hidden;
	flex-direction: column;
	text-align: left;
	width: 100%;
	padding: 2rem;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		padding: 1rem;
	}
`;

const Header = styled.div`
	display: flex;
	font-size: 2rem;
`;

const Slot = styled.div`
	position: relative;
	margin: ${(props) => props.margin};
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: left;
	padding: 1rem;
	gap: 0.5rem;
	width: max-content;
	border-radius: 10px;
	transition: 0.2s all ease-in-out;
	box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
		rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
	&:hover {
		transform: ${(props) => (props.disableHover ? "" : "scale(1.05)")};
		cursor: pointer;
	}
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		width: 100%;
	}
`;

const Div = styled.div`
	color: ${(props) => props.color};
	background: ${(props) => props.background};
	height: ${(props) => props.height};
	width: ${(props) => props.width};
	display: flex;
	gap: ${(props) => props.gap};
	flex-direction: ${(props) => props.flexDirection};
	align-items: ${(props) => props.alignItems};
	justify-content: ${(props) => props.jContent};
	flex-wrap: ${(props) => props.flexWrap};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	box-shadow: ${(props) => props.boxShadow};
	border-radius: ${(props) => props.borderRadius};
	align-self: ${(props) => props.alignSelf};
	border: ${(props) => props.border};
`;

Div.defaultProps = {
	alignItems: "center",
	jContent: "center",
	flexWrap: "",
	width: "100%",
};

const Delete = styled.div`
	position: absolute;
	top: -8px;
	right: -8px;
	z-index: ${zIndex.stickyHeader};
	cursor: pointer;
`;

const DeleteModule = styled.div`
	position: absolute;
	top: -5px;
	right: -5px;
	z-index: ${zIndex.stickyHeader};
	cursor: pointer;
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	margin: ${(props) => props.margin};
`;

const CardHeader = styled.div`
	font-size: 1.5rem;
	font-weight: 600;
	text-align: left;
	width: 100%;
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: ${zIndex.modalBackdrop};
`;

const ConfirmModal = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	width: 22rem;
	border-radius: 10px;
	overflow-x: hidden;
	z-index: ${zIndex.modal};
`;

const MODES = {
	ADD: "ADD",
	UPDATE: "UPDATE",
};

const States = {
	"LOADING" : "LOADING",
	"OK" : "OK",
	"ERROR" : "ERROR"
}

const COMPONENTS = {
	"REPLENISH_WITH_SHEET" : "REPLENISH_WITH_SHEET"
}

const Replenish = (props) => {
	const {
		machineID,
		kitchenId,
		replenishmentData,
		addToReplenishmentData,
		removeFromReplenishmentData,
		updateReplenishmentData,
		clearReplenishmentData,
	} = props;

	const [formData, setFormData] = useState({});
	const [mode, setMode] = useState(MODES.ADD);
	const [addModal, showAddModal] = useState(false);
	const [componentsState, updateComponentsStates] = useState({ [COMPONENTS.REPLENISH_WITH_SHEET] : States.OK });
	const [sheetName, setSheetName] = useState("");
	const [showSheetModal, toggleSheetModal] = useState(false);
	const [showCsvModal, toggleCsvModal] = useState(false);
	const csvFileInput = useRef();

	// eslint-disable-next-line no-labels
	const dockingActions = Object.entries(DOCKING_ACTIONS).map(
		([key, value]) => ({ head: key, value })
	);

	function preparePayload(payload) {
		for (const module in payload) {
			for (const slot in payload[module]) {
				delete payload[module][slot].name;
			}
			payload[module] = { slots: payload[module] };
		}
		return { modules: payload };
	}

	function removeItem(event, moduleId, slotId) {
		event.stopPropagation();
		removeFromReplenishmentData({ moduleId, slotId });
	}

	async function sendReplenishmentRequest() {
		let replenishmentPayload = deepCopy(replenishmentData);
		replenishmentPayload = preparePayload(replenishmentPayload);
		const response = await InventoryService.replenish(kitchenId, {
			replenishmentPayload,
		});
		const { data, error } = response;
		if (data) {
			successNotification("Replenished Inventory Successfully");
			clearReplenishmentData();
		}
		if (error) {
			errorNotification("Could not Replenish Inventory");
		}
	}

	async function replenishWithCSVRequest() {

		const csvInput = document.getElementById('replenishmentCsv');
		
		if(!csvInput?.files?.[0]) {
			errorNotification("Please upload a file first.");
			return;
		}

		let formData = new FormData();
		formData.append('file', csvInput.files[0])
		const response = await InventoryService.replenishWithCsv(kitchenId, formData);
		const { data, error } = response;
		if (data) {
			successNotification("Replenished Inventory Successfully");
			toggleCsvModal(false);
		}
		if (error) {
			errorNotification(error);
		}
	}

	async function sendReplenishWithSheetRequest(handleLoading = true) {
		if(!sheetName.length) {
			errorNotification("No sheet name provided");
			return;
		}
		if(handleLoading) updateComponentsStates((prev) => ({ ...prev, [COMPONENTS.REPLENISH_WITH_SHEET] : States.LOADING }));
		const response = await InventoryService.replenishFromSheet(kitchenId, {
			sheetTitle: sheetName,
			restaurantId: machineID
		});
		const { data, error } = response;
		if(data) {
			successNotification("Replenished sucessfully");
			if(handleLoading) updateComponentsStates((prev) => ({ ...prev, [COMPONENTS.REPLENISH_WITH_SHEET] : States.OK }));
		}
		if(error) {
			errorNotification(error);
			if(handleLoading) updateComponentsStates((prev) => ({ ...prev, [COMPONENTS.REPLENISH_WITH_SHEET] : States.OK }));
		}
	}

	function handleUserSubmit() {
		// const allGood = validateEnteredData(formData);
		if (mode === MODES.UPDATE) {
			updateReplenishmentData(formData);
		} else {
			addToReplenishmentData(formData);
		}
		showAddModal(false);
		setFormData({});
	}

	function addInModule(moduleId) {
		setMode(MODES.ADD);
		setFormData({ moduleId });
		showAddModal(true);
	}

	function addtoPayload() {
		setMode(MODES.ADD);
		showAddModal(true);
	}

	function updateModuleData(data) {
		setMode(MODES.UPDATE);
		setFormData(data);
		showAddModal(true);
	}

	function renderReplenishmentData(replenishmentData) {
		let renderData = [];
		if (Object.keys(replenishmentData).length) {
			for (const module in replenishmentData) {
				let moduleData = [];
				for (const slot in replenishmentData[module]) {
					const { name, filledAmount, action } =
						replenishmentData[module][slot];
					const itemId = `${module}-${slot}`;
					moduleData.push(
						<Slot
							onClick={() =>
								updateModuleData({
									moduleToUpdate: module,
									slotToUpdate: slot,
									slotId: slot,
									moduleId: module,
									...replenishmentData[module][slot],
								})
							}>
							<Span>Slot {slot}</Span>
							<Span>
								{name} - <Span fontWeight="900">{filledAmount || "n/a"}</Span>
							</Span>
							<Span>{beautifyKey(action)}</Span>
							<Delete
								id={itemId}
								onClick={(e) => {
									removeItem(e, module, slot);
								}}>
								<Cross width="15px" />
							</Delete>
						</Slot>
					);
				}
				moduleData.push(
					<Slot
						onClick={() => {
							addInModule(module);
						}}
						disableHover>
						+
					</Slot>
				);
				renderData.push(
					<Card>
						<CardHeader>Module {module}</CardHeader>
						<Div flexWrap="wrap" gap="1rem" margin="1.5rem 0 0 0" jContent="">
							{moduleData}
						</Div>
						<DeleteModule
							onClick={(e) => {
								removeItem(e, module);
							}}>
							<Cross width="20px" />
						</DeleteModule>
					</Card>
				);
			}
		}
		return renderData;
	}

	return (
		<Page>
			<Div
				width="100%"
				alignItems="center"
				jContent="space-between"
				flexWrap="wrap"
				gap="1rem">
				<Header>Replenishment</Header>
				<Div width={"max-content"} gap="1rem">
					<Button active onClick={() => {toggleSheetModal(true)}}>
						Replenish by Sheet
					</Button>
					<Button active onClick={() => toggleCsvModal(true)}>
						Replenish with CSV
					</Button>
					{Object.keys(replenishmentData).length ? (
						<>
							<Button active onClick={sendReplenishmentRequest}>
								Replenish
							</Button>
							<Button active onClick={clearReplenishmentData}>
								Clear All
							</Button>
						</>
					) : (
						""
					)}
				</Div>
			</Div>
			<Div
				gap={"2rem"}
				margin={"1rem 0 0 0"}
				flexWrap="wrap"
				jContent="flex-start"
				width="100%">
				{renderReplenishmentData(replenishmentData)}
			</Div>
			<CSSTransition
				in={addModal}
				timeout={1000}
				classNames="module"
				unmountOnExit>
				<Overlay>
					<ConfirmModal>
						<Div
							color="#fff"
							background="rgba(45, 35, 66, 0.8)"
							padding="1rem"
							jContent="space-between">
							<Span fontSize="1.4rem">Add Slot</Span>
							<img
								style={{
									height: "1.5rem",
									filter:
										"invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
								src={close}
								alt="close"
								onClick={() => {
									showAddModal(false);
								}}
							/>
						</Div>
						<Div gap="0.5rem" flexDirection="column" padding="1rem">
							<Div
								jContent=""
								alignItems=""
								flexDirection="column"
								position="relative"
								gap="0.3rem">
								<Span>Module</Span>
								<InputBox
									type="text"
									onChange={(e) => {
										setFormData((prev) => {
											return { ...prev, moduleId: e.target.value };
										});
									}}
									defaultValue={formData?.moduleId}
									border="1px solid rgba(45, 35, 66, 0.4)"
									width="100%"
									padding="0.6rem 0.8rem"
								/>
							</Div>
							<Div
								jContent=""
								alignItems=""
								flexDirection="column"
								position="relative"
								gap="0.3rem">
								<Span>Slot</Span>
								<InputBox
									type="text"
									onChange={(e) => {
										setFormData((prev) => {
											return { ...prev, slotId: e.target.value };
										});
									}}
									defaultValue={formData?.slotId}
									border="1px solid rgba(45, 35, 66, 0.4)"
									width="100%"
									padding="0.6rem 0.8rem"
								/>
							</Div>
                            <Div
								jContent=""
								alignItems=""
								flexDirection="column"
								position="relative"
								gap="0.3rem">
								<Span>Item</Span>
                                <SearchBarWithResults
								height="10rem"
								colToShow="name"
								colToStore="_id"
								search={InventoryService.searchIngredients}
								onChange={(value) => {
									setFormData((prev) => {
										return { ...prev, itemId: value._id, name: value.name };
									});
								}}
							/>
							</Div>

							<Div
								jContent=""
								alignItems=""
								flexDirection="column"
								position="relative"
								gap="0.3rem">
								<Span>Filled Amount</Span>
								<InputBox
									type="number"
									onChange={(e) => {
										setFormData((prev) => {
											return { ...prev, filledAmount: e.target.value };
										});
									}}
									defaultValue={formData?.filledAmount}
									border="1px solid rgba(45, 35, 66, 0.4)"
									width="100%"
									padding="0.6rem 0.8rem"
								/>
							</Div>
							<Div
								jContent=""
								alignItems=""
								flexDirection="column"
								position="relative"
								gap="0.3rem">
								<Span>Docking Action</Span>
								<Dropdown
									optionsList={dockingActions}
									value={formData?.action}
									boxShadow=""
									onChange={(value) => {
										setFormData((prev) => {
											console.log(value);
											return { ...prev, action: value };
										});
									}}
									border="1px solid rgba(45, 35, 66, 0.4)"
									width="100%"
									padding="0.6rem 0.8rem"
								/>
							</Div>
						</Div>
						<Div gap="1rem" jContent="flex-end" padding="1rem">
							<Button onClick={() => showAddModal(false)}>Cancel</Button>
							<SuccessButton onClick={handleUserSubmit}>Confirm</SuccessButton>
						</Div>
					</ConfirmModal>
				</Overlay>
			</CSSTransition>

			<CSSTransition
				in={showSheetModal}
				timeout={1000}
				classNames="module"
				unmountOnExit>
				<Overlay>
					<ConfirmModal>
					<Div
							color="#fff"
							background="rgba(45, 35, 66, 0.8)"
							padding="1rem"
							jContent="space-between">
							<Span fontSize="1.4rem">Replenish by Sheet</Span>
							<img
								style={{
									height: "1.5rem",
									filter:
										"invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
								src={close}
								alt="close"
								onClick={() => {
									toggleSheetModal(false);
								}}
							/>
						</Div>
						<Div alignItems="" gap="0.3rem" flexDirection="column" padding="1rem 1rem 0 1rem">
							<Span>Sheet Name</Span>
							<InputBox width="100%" type="text" id="replenishmentSheet" onChange={(e) => setSheetName(e.target.value)} />
							<Div gap="1rem" jContent="flex-end" padding="1rem">
								<Button onClick={() => toggleSheetModal(false)}>Cancel</Button>
								<SuccessButton disabled={componentsState[COMPONENTS.REPLENISH_WITH_SHEET] === States.LOADING} onClick={sendReplenishWithSheetRequest} >
									Confirm
								</SuccessButton>
							</Div>
						</Div>
					</ConfirmModal>
				</Overlay>
			</CSSTransition>

			<CSSTransition
				in={showCsvModal}
				timeout={1000}
				classNames="module"
				unmountOnExit>
				<Overlay>
					<ConfirmModal>
					<Div
							color="#fff"
							background="rgba(45, 35, 66, 0.8)"
							padding="1rem"
							jContent="space-between">
							<Span fontSize="1.4rem">Replenish by CSV</Span>
							<img
								style={{
									height: "1.5rem",
									filter:
										"invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
								src={close}
								alt="close"
								onClick={() => {
									toggleCsvModal(false);
								}}
							/>
						</Div>
						<Div alignItems="" gap="0.3rem" flexDirection="column" padding="1rem 1rem 0 1rem">
							<Span>File</Span>
							<InputBox  width="100%" type="file" id="replenishmentCsv" accept=".csv" />
							<Div gap="1rem" jContent="flex-end" padding="1rem">
								<Button onClick={() => toggleCsvModal(false)}>Cancel</Button>
								<SuccessButton disabled={componentsState[COMPONENTS.REPLENISH_WITH_SHEET] === States.LOADING} onClick={replenishWithCSVRequest} >
									Confirm
								</SuccessButton>
							</Div>
						</Div>
					</ConfirmModal>
				</Overlay>
			</CSSTransition>

		</Page>
	);
};

const mapStateToProps = (state) => {
	const { inventory, landing } = state;
	return { ...inventory, ...landing };
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators(
		{
			...OperationActions,
		},
		dispatch
	),
});

export default connect(mapStateToProps, mapDispatchToProps)(Replenish);
